const EDITION = process.env.REACT_APP_EDITION;

const APP_EDITION = {
	isPro: 'undefined' !== typeof EDITION && String(process.env.REACT_APP_EDITION).length > 0,
	isCommunity:
		'undefined' !== typeof EDITION &&
		String(process.env.REACT_APP_EDITION).toLowerCase().includes('community'),
	isDefault: 'undefined' === typeof EDITION || String(process.env.REACT_APP_EDITION).length === 0,
	toString: 'undefined' === typeof EDITION ? '' : EDITION,
};

export default APP_EDITION;
